import classNames from 'classnames';
import React, {ReactNode} from 'react';
import {useContentWrapperContext} from '../ContentWrapper';

import './TopBar.scss';

export interface TopBarProps {
  children?: ReactNode;
  full?: boolean;
  positionFixed?: boolean;
}

export const TopBar: React.FC<TopBarProps> = ({ children, full, positionFixed }) => {
  const { isControlVisible } = useContentWrapperContext();

  return (
    <div
      className={classNames('content-wrapper__top-bar', {
        'content-wrapper__top-bar--inactive': !isControlVisible,
        'content-wrapper__top-bar--fixed': positionFixed,
      })}
    >
      <div className={classNames('content-wrapper__bar', { 'content-wrapper__bar--full': full })}>{children}</div>
    </div>
  );
};
